// extracted by mini-css-extract-plugin
module.exports = {"submit":"Buttton_submit__3cyov","danger":"Buttton_danger__2x6xa"};